import { render, staticRenderFns } from "./light_point_Case.vue?vue&type=template&id=2569716e&scoped=true"
import script from "./light_point_Case.vue?vue&type=script&lang=js"
export * from "./light_point_Case.vue?vue&type=script&lang=js"
import style0 from "./light_point_Case.vue?vue&type=style&index=0&id=2569716e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2569716e",
  null
  
)

export default component.exports